import React, { useContext } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as yup from "yup";

import { Input } from "../../../../../../../../../components/Form";
import PhoneInput from "../../../../../../../../../components/Form/PhoneInput";
import Checkbox from "Components/Form/Checkbox";
import useYupValidation from "../../../../../../../../../hooks/useYupValidation";
import { MemberStaff } from "../../../../../../../../../models/members/member.staff";
import { MemberContext } from "../../context";
import { Wrapper } from "./styles";

type Props = {
  errors?: yup.ValidationError[];
};

export default function StaffDetails({ errors = [] }: Props) {
  const { t: translate } = useTranslation();
  const { location } = useHistory<{ isView: boolean }>();
  const { member, handleUpdateMember } = useContext(MemberContext);
  const { fieldHasError, getErrorByField } = useYupValidation(errors);

  return (
    <Wrapper>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Input
            disabled={location?.state?.isView}
            label={translate("emergencyName")}
            value={(member as MemberStaff)?.emergencyName}
            onChange={(event) => handleUpdateMember("emergencyName", event.target.value)}
            placeholder={translate("typeHere")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PhoneInput
            disabled={location?.state?.isView}
            label={translate("emergencyPhone")}
            value={(member as MemberStaff)?.emergencyPhone}
            onChange={(number) => handleUpdateMember("emergencyPhone", number)}
            placeholder={translate("typeHere")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Input
            disabled={location?.state?.isView}
            label={translate("emergencyEmail")}
            value={(member as MemberStaff)?.emergencyEmail}
            onChange={(event) => handleUpdateMember("emergencyEmail", event.target.value)}
            placeholder={translate("typeHere")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Input
            disabled={location?.state?.isView}
            label={translate("emergencyRelationship")}
            value={(member as MemberStaff)?.emergencyRelationship}
            onChange={(event) => handleUpdateMember("emergencyRelationship", event?.target.value)}
            placeholder={translate("typeHere")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Input
            disabled={location?.state?.isView}
            label={translate("residencyStatus")}
            required
            value={(member as MemberStaff)?.residencyStatus}
            onChange={(event) => handleUpdateMember("residencyStatus", event.target.value)}
            error={fieldHasError("residencyStatus")}
            errorMessage={getErrorByField("residencyStatus")}
            placeholder={translate("typeHere")}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Grid item>
            <Checkbox
              disabled={location?.state?.isView}
              label={translate("displayInDispatchModule")}
              data-cy="checkboxDisplayInDispatch"
              checked={!!(member as MemberStaff)?.displayInDispatch}
              onChange={(_, checked) => {
                handleUpdateMember("displayInDispatch", checked);
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
}
